import { render, staticRenderFns } from "./prospects.vue?vue&type=template&id=5cd12d10&scoped=true"
import script from "./prospects.vue?vue&type=script&lang=js"
export * from "./prospects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd12d10",
  null
  
)

export default component.exports